import { render } from "./manager-detail.vue?vue&type=template&id=2f8e7366&scoped=true"
import script from "./manager-detail.vue?vue&type=script&lang=js"
export * from "./manager-detail.vue?vue&type=script&lang=js"

import "./manager-detail.vue?vue&type=style&index=0&id=2f8e7366&lang=less&scoped=true"

import exportComponent from "/Users/cain/Workspaces/projects/roar/roar-fe/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.30_vue@3.5.30_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f8e7366"]])

export default __exports__